'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});
var addToShelf = function addToShelf(shelfToAdd) {
  return {
    eventCategory: 'AddToShelf',
    eventAction: 'click',
    eventLabel: shelfToAdd
  };
};

exports.default = addToShelf;


//////////////////
// WEBPACK FOOTER
// ./~/@bibliocommons/ga-event-templates/lib/addToShelf.js
// module id = 1417
// module chunks = 1